import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import MyOrdersList from 'components/Account/MyOrder/MyOrdersList/MyOrdersList';
import useOrderHistory from 'hooks/useOrderHistory';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_ACCOUNT } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function History(): JSX.Element {
  const { t } = useTranslation(['ordersPage']);
  const { orders, evtOrders } = useOrderHistory();

  useGtmPageView(GTM_PAGE_ACCOUNT, '');

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      history.scrollRestoration = 'manual';
    }

    return () => {
      if ('scrollRestoration' in window.history) {
        history.scrollRestoration = 'auto';
      }
    };
  }, []);

  if (!orders || !evtOrders) {
    return <RenderHelmet />;
  }

  return (
    <div>
      <RenderHelmet />
      {orders?.length === 0 && evtOrders?.length === 0 && (
        <>
          <div className={styles.titleArea}>
            <label>{t('LABEL_ORDER_LAST_ORDERS')}</label>
          </div>
          <div className={styles.ordersAlert}>
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <span>{t('LABEL_NO_ORDERS_PLACED')}</span>
          </div>
        </>
      )}

      {(orders?.length !== 0 || evtOrders?.length !== 0) && (
        <MyOrdersList ordersdata={orders} evtordersdata={evtOrders} />
      )}
    </div>
  );
}

function RenderHelmet(): JSX.Element {
  const { t } = useTranslation('ordersPage');

  return (
    <Helmet>
      <title>
        {t('META_TITLE_TEMPLATE', {
          title: t('ORDER_HISTORY_META_TITLE'),
          ns: 'translation',
        })}
      </title>
    </Helmet>
  );
}
